<mat-card
  class="class-card mat-elevation-z2"
  (click)="onClick()"
  role="button"
  tabindex="0"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick()"
  [attr.aria-label]="'View class: ' + cls.name">

  <mat-card-header class="card-header">
    <span class="status-chip" [ngClass]="statusChipClass">{{ statusLabel }}</span>
    <mat-card-title class="card-title">{{ cls.name }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="card-content">
    <p class="meta-row course-row">
      <mat-icon class="meta-icon">school</mat-icon>
      <span class="meta-text">{{ courseName }}</span>
    </p>

    <p class="meta-row" *ngIf="startDate || endDate">
      <mat-icon class="meta-icon">calendar_today</mat-icon>
      <span class="meta-text">
        {{ formatDate(startDate) }}<span *ngIf="endDate"> → {{ formatDate(endDate) }}</span>
        <span class="extra-badge" *ngIf="extraRangeCount > 0">&nbsp;+{{ extraRangeCount }} more</span>
      </span>
    </p>

    <p class="meta-row" *ngIf="startTime || endTime">
      <mat-icon class="meta-icon">schedule</mat-icon>
      <span class="meta-text">Daily {{ startTime }} – {{ endTime }}</span>
    </p>
  </mat-card-content>

  <div class="card-footer">
    <div class="trainer-row">
      <span
        *ngFor="let av of trainerAvatars"
        class="avatar-chip"
        [style.background-color]="av.color"
        [matTooltip]="av.label"
        aria-hidden="true">{{ av.label }}</span>
      <span class="avatar-overflow" *ngIf="trainerOverflow > 0">+{{ trainerOverflow }}</span>
    </div>
    <div class="participant-row" *ngIf="participantCount > 0">
      <mat-icon class="footer-icon">group</mat-icon>
      <span class="footer-count">{{ participantCount }}</span>
    </div>
    <button mat-icon-button class="card-archive-btn"
            *ngIf="canArchive"
            matTooltip="Archive this class"
            (click)="onArchiveClick($event)"
            aria-label="Archive class">
      <mat-icon>inventory_2</mat-icon>
    </button>
  </div>

</mat-card>
